<template>
  <v-container class="User">
    <v-sheet
      min-height="300"
      rounded="lg"
      elevation="6"
    >
    <Toolbar :handle-submit="addUser" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-account</v-icon>{{$t('administration.user.user')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <UserForm ref="UserForm" :values="item" :errors="violations" :loginActiv="true" />
    <Loading :visible="isLoading" />
  </v-sheet>
</v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import UserForm from '../../components/user/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'User';

const { mapFields } = createHelpers({
  getterType: 'user/getField',
  mutationType: 'user/updateField'
});

export default {
  name: 'UserCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    UserForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'violations']),
    ...mapState('user', {
      actioned: 'actioned',
      action: 'action',
      error: 'error',
      isLoading: 'isLoading',
    })
  },
  methods: {
    ...mapActions('user', [ 'reset']),
    ...mapActions({
      userPushAction: 'user/action'
    }),
    addUser() {
      const UserForm = this.$refs.UserForm;
      UserForm.$v.$touch();
      if (!UserForm.$v.$invalid) {
        this.userPushAction({action: 'user/new',values: {
         'firstname' :UserForm.$v.item.$model.firstname ,
         'lastname' : UserForm.$v.item.$model.lastname ,
         'login' : UserForm.$v.item.$model.login ,
         'email' : UserForm.$v.item.$model.email   ,
         'enabled' : UserForm.$v.item.$model.enabled ,
         'profil' : UserForm.$v.item.$model.profil.id,
         'profilInterface' : UserForm.$v.item.$model.profilInterface.id,
       }});
      } else {
        console.log('error');
      }
    },

    Added(item) {

      this.$router.push({ name: `UserCreateConfirm` , params: { id: '/api/users/'+item.user.id, passwordtemp: item.passwordTemp }});
      this.showMessage(item.message);
    },
  },
  watch: {
    actioned(actioned) {
      if (!actioned) {
        return;
      }
      if (this.action == 'user/new') {
        this.Added(actioned);
      }
    },

    error(message) {
      message && this.showError(message);
    }
  }
};
</script>
